import { render, staticRenderFns } from "./AdminDetail.vue?vue&type=template&id=d9cb814c&scoped=true&"
import script from "./AdminDetail.vue?vue&type=script&lang=js&"
export * from "./AdminDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdminDetail.vue?vue&type=style&index=0&id=d9cb814c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cb814c",
  null
  
)

export default component.exports